interface BottomDetailProps {
  uptime: number;
  responseTime: number;
}
export const BottomDetail: React.FC<BottomDetailProps> = ({
  uptime,
  responseTime
}) => <div className='space-y-1 rounded-b-lg bg-background-deep/60 p-3 text-xs backdrop-blur'>
    <div className='flex justify-between'>
      <span>Uptime:</span>
      <span className='font-mono'>{uptime}%</span>
    </div>
    <div className='flex justify-between'>
      <span>Response:</span>
      <span className='font-mono'>{responseTime}ms</span>
    </div>
  </div>;